export const CONFIGURATION_ENTITY_LIST = {
  ORGANIZATION: ["ORGANIZATION", "USER"],
  CURRICULUM: ["CURRICULUM_PROGRAM", "USER"],
  CURRICULUM_AND_GRADE: ["CURRICULUM_PROGRAM", "GRADE", "USER"],
  COURSE: ["COURSE", "USER"],
  ORGANIZATION_ONLY: ["ORGANIZATION"],
  CURRICULUM_ONLY: ["CURRICULUM_PROGRAM"],
  COURSE_ONLY: ["COURSE"],
  USER_ONLY: ["USER"],
  IDENTITY: ["IDENTITY", "ORGANIZATION"],
  ORGANIZATION_WITH_USER_AND_IDENTITY: ["ORGANIZATION", "USER", "IDENTITY"],
  GRADE_ONLY: ["GRADE"],
  IDENTITY_ONLY: ["IDENTITY"],
  LEARNING_COURSE: ["LEARNING_COURSE", "USER"],
  CURRICULUM_WITH_ACADEMIC_YEAR: ["CURRICULUM_PROGRAM", "ACADEMIC_YEAR"],
  CURRICULUM_WITH_LEARNING_COURSE: [
    "CURRICULUM_PROGRAM",
    "LEARNING_COURSE",
    "USER",
  ],
};

/**
 * Defines control parameters that should be toggled when a module is enabled/disabled.
 *
 * Each module entry should provide:
 *  - `controlParameters`: list of control parameter keys to update
 *  - `shouldSkip`: guard to conditionally skip applying the config
 *
 * Note: toggling control parameters here can affect permission
 * resolution if they are also used in role or curriculum-level RnP.
 *
 *  Example structure:
 *
 * {
 *   moduleKey: {
 *     controlParameters: [
 *       DEPENDENT_CONTROL_PARAMETER_1,
 *       DEPENDENT_CONTROL_PARAMETER_2,
 *     ],
 *     shouldSkip: () => !shouldToggleDependentPermissions(),
 *   },
 * }
 */
export const MODULE_DEPENDENT_CONTROL_PARAMETERS_CONFIG = {};
